















import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './components/content-loader.vue';
import { defineComponent } from '@vue/composition-api';
import MyCouponTab from './components/my-coupon-tab.vue';
import MyWePointsTab from './components/my-wepoints-tab.vue';
import { useUserAssetsCount } from './use-user-assets';

export default defineComponent({
  name: 'MyCouponStamp',
  components: {
    BaseComponent,
    ContentLoader,
    MyCouponTab,
    MyWePointsTab,
  },
  props: {
    noTopBanner: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { isReady, assetsCountData } = useUserAssetsCount();
    return {
      isReady,
      assetsCountData,
    };
  },
});
